export default "__VITE_ASSET__ed2a36bb__"